import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the iframe state domain
 */

const selectIframeDomain = state => state.iframe || initialState;

const makeSelectIframeState = () => createSelector(selectIframeDomain, subState => subState);

/**
 * Other specific selectors
 */

const makeSelectLoading = () => createSelector(selectIframeDomain, subState => subState.loading);

const makeSelectError = () => createSelector(selectIframeDomain, subState => subState.error);

export { makeSelectIframeState, makeSelectLoading, makeSelectError };
